// shabba-dashboard/src/constants/instruments.ts

export const INSTRUMENTS = [
  { label: 'CRDB',     secId: 'LPPJ' },
  { label: 'VODA',     secId: 'WVSL' },
  { label: 'AFRIPRISE',secId: 'KKRA' },
  { label: 'DCB',      secId: 'FMDA' },
  { label: 'NICO',     secId: 'IGTT' },
  { label: 'NMB',      secId: 'BDHK' },
];

const LABEL_BY_SECID = INSTRUMENTS.reduce<Record<string,string>>((m, {label, secId}) => {
  m[secId.toUpperCase()] = label;
  return m;
}, {});

export function labelForSecId(secId: string): string {
  return LABEL_BY_SECID[(secId || '').toUpperCase()] || secId || 'N/A';
}

const SECID_BY_LABEL = INSTRUMENTS.reduce<Record<string, string>>((m, { label, secId }) => {
  m[label.toUpperCase()] = secId.toUpperCase();
  return m;
}, {});

/** Ticker for a secId, or the input unchanged if it is already a ticker. */
export function tickerFor(symbol: string): string {
  const s = (symbol || '').toUpperCase();
  return LABEL_BY_SECID[s] ?? s;
}

/** SecId for a ticker, or the input unchanged if it is already a secId. */
export function secIdFor(symbol: string): string {
  const s = (symbol || '').toUpperCase();
  return SECID_BY_LABEL[s] ?? s;
}

/**
 * Read a Map that may be keyed by EITHER a DSE secId or a ticker.
 *
 * THE PROBLEM THIS SOLVES: `selectedSymbol` is a secId ('LPPJ'), while
 * `inventoryBySymbol`, the settlement `*_by_ticker` maps and `positions[].symbol` are keyed by
 * TICKER ('CRDB'). `regimeBySymbol` is worse — signalsHandler writes it under a secId and
 * engineStateHandlers writes it under a ticker, so the same map holds both namespaces.
 *
 * A plain `.get(selectedSymbol)` against a ticker-keyed map silently returns undefined, which
 * renders as an empty panel rather than an error. That is exactly what the right-rail INVENTORY
 * tab did: it had never displayed a position.
 */
export function resolveBySymbol<T>(map: Map<string, T> | undefined | null, symbol: string): T | undefined {
  if (!map) return undefined;
  const s = (symbol || '').toUpperCase();
  return map.get(s) ?? map.get(tickerFor(s)) ?? map.get(secIdFor(s));
}